(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dope-season-promo"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initSeasonPromo() {
    document.querySelectorAll('[data-season-promo]').forEach(panel => {
      if (panel.dataset.ready) return;
      panel.dataset.ready = 'true';
      const end = new Date(panel.dataset.deadline).getTime();
      const tick = () => {
        const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (!remaining) { panel.hidden = true; panel.style.display = 'none'; return false; }
        const values = {days:Math.floor(remaining / 86400),hours:Math.floor(remaining / 3600) % 24,minutes:Math.floor(remaining / 60) % 60,seconds:remaining % 60};
        Object.entries(values).forEach(([unit,value]) => { panel.querySelector('[data-unit="'+unit+'"]').textContent = String(value).padStart(2,'0'); });
        return true;
      };
      if (tick()) { const interval = setInterval(() => { if (!panel.isConnected || !tick()) clearInterval(interval); },1000); }
    });
  }
  initSeasonPromo();
  document.addEventListener('shopify:section:load', initSeasonPromo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
